import { ChangeDetectionStrategy, Component } from '@angular/core';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { PROFILE_TABS_NAMES } from 'app/modules/user-modules/profile-modules/profile-base/constants/profile-tabs.constants';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { LogoComponent } from '../../../core-modules/layout/logo/logo.component';
import { RpcAvatarComponent } from '../../../core-modules/controls/components/rpc-avatar/rpc-avatar.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'landing-toolbar',
    templateUrl: './landing-toolbar.component.html',
    styleUrls: ['./landing-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LogoComponent, RpcAvatarComponent, AsyncPipe]
})
export class LandingToolbarComponent {
    public readonly customerFullName$ = this.userStoreService.getCustomerFullName();
    public readonly customerProfileImage$ = this.userStoreService.getCustomerProfileImage();

    constructor(
        private readonly userStoreService: UserStoreService,
        private readonly routeService: RouteService,
    ) { }

    public onMyProfileClicked(): void {
        this.routeService.navigate(RpcRoute.Profile, { state: { tab: PROFILE_TABS_NAMES.GENERAL } }).catch(() => { });
    }

}
